import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CentralReportsCard from '../CentralReportsCard/CentralReportsCard';
import ViewButton from '../ViewButton/ViewButton';
import ReportIcons from '../ReportIcons/ReportIcons';
import { textSx, rowGridSx, columnGridSx, boxSx } from './styles';

type ReportSectionProps = {
  sectionHeader: string;
  reportAmount: number;
};

export default function ReportSection({ sectionHeader, reportAmount }: ReportSectionProps) {
  /* temporarily using a count of how many reports are present (report amount) because I dont know how reports will be pulled in yet */

  if (reportAmount <= 0) return null;

  return (
    <Grid item xs={12} sx={columnGridSx}>
      <Box sx={boxSx}>
        <ReportIcons sectionHeader={sectionHeader} />
        <Typography sx={textSx} color='text.primary'>
          {sectionHeader}
        </Typography>
      </Box>
      <Grid item xs={12} sx={rowGridSx}>
        <CentralReportsCard description='' title='' url='' />
        <CentralReportsCard description='' title='' url='' />
        <CentralReportsCard description='' title='' url='' />
      </Grid>
      {reportAmount > 6 ? <ViewButton /> : null}
    </Grid>
  );
}
